module.exports = __webpack_public_path__ + "assets/d2d460a8b72ed3cf7a718a3a3c0b9f93.mp3";